import { computed } from '@vue/composition-api';
import deepmerge from 'deepmerge';
import { useStore } from '@/core/store';

export default function useGetStation (locationId) {
  const store = useStore();

  const stations = computed(() => {
    return store.getters.locationStations(locationId)
      .map(station => deepmerge({}, station));
  });

  function getExperienceStations (experienceId) {
    return stations.value.filter(station => station.experience.id === experienceId);
  }

  return {
    stations,
    getExperienceStations,
  };
}
